module.exports = __webpack_public_path__ + "static/media/SzenokTinyLogo(for ico).30fa4797.svg";